
import { combineReducers } from 'redux';

import mapMultiScene from './mapmultiscene';

export default combineReducers({
    mapMultiScene
});
